import $http from '@/http';
import eventBus from '@/EventBus';
import Vue from 'vue';

const getDefaultState = () => {
  return {
    incidentList: [],
    mergeSearchKeyword: '',
    timer: null, // 발주티켓 다운로드 폴링 체크를 위한 객체
    jobId: null, // 발주티켓 엑셀 다운로드 job id. 비어있을 때에만 새로운 다운로드 요청이 가능함.
    canRequest: true // 발주티켓 엑셀 다운로드 요청 가능 여부
  };
};
const state = getDefaultState();

const getters = {
  incidentList: (state) => {
    return state.incidentList;
  },
  mergeSearchKeyword: (state) => {
    return state.mergeSearchKeyword;
  }
};

const mutations = {
  setIncidentList(state, list) {
    state.incidentList = list;
  },
  setMergeSearchKeyword(state, keyword) {
    state.mergeSearchKeyword = keyword;
  }
};

const actions = {
  setIncidentList(context, list) {
    context.commit('setIncidentList', list);
  },
  requestOrderTicketExcelDownload({ state, dispatch }, payload) {
    function alertMessage(message) {
      eventBus.$emit('DialogPopup', {
        useDialog: true,
        messageHTML: `<p class="txt">${message}</p>`,
        getBtnName: '확인',
        getButtonEvent: () => {}
      });
    }
    if (!state.canRequest) {
      return;
    }
    if (state.jobId) {
      alertMessage('현재 작업이 실행 중입니다.<br/>엑셀 생성이 완료된 후 다시 다운로드해 주세요.');
      return;
    }
    state.canRequest = false; // 엑셀 다운로드 요청 중에는 추가 요청을 막음
    // 발주티켓 엑셀 다운로드 요청
    $http({
      url: '/api/apps/v1/tickets/orders/excel',
      method: 'POST',
      data: payload
    })
      .then((response) => {
        if (response.status === 200) {
          Vue.toasted.info('엑셀 생성 작업이 시작되었습니다.<br/>다량의 데이터로 인해 처리에<br/>시간이 소요될 수 있습니다.');
          state.jobId = response.data.jobId;
          const brandId = payload.brandId;
          state.timer = setInterval(() => {
            dispatch('checkIsOrderTicketDownloadReady', brandId);
          }, 2000);
          setTimeout(() => {
            // 5분이 지나면 폴링 중지하고 jobId 초기화
            if (!state.timer) return;
            if (state.jobId !== response.data.jobId) return;
            clearInterval(state.timer);
            state.timer = null;
            state.jobId = null;
            Vue.toasted.error('데이터 양이 많아 엑셀 생성에 실패했습니다. 조회 조건을 줄인 후 다시 시도해 주세요.');
          }, 300000);
        } else {
          alertMessage(response.data.message || '엑셀 다운로드 요청에 실패했습니다.');
          state.jobId = null;
        }
      })
      .catch((err) => {
        alertMessage(err.message || err);
        state.jobId = null;
      })
      .finally(() => {
        state.canRequest = true;
      });
  },
  checkIsOrderTicketDownloadReady({ state }, payload) {
    if (!state.jobId) return;
    $http({
      url: `/api/apps/v1/tickets/orders/excel-status/${state.jobId}`,
      method: 'GET',
      params: {
        brandId: payload
      }
    })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.stats === 'PROCESSING') return;
          if (response.data.stats === 'FAILED') {
            Vue.toasted.error('엑셀 파일 생성에 실패했습니다.<br/>잠시 후 다시 시도해 주세요.');
          }
          if (response.data.stats === 'DONE') {
            Vue.toasted.success('엑셀 파일 생성이 완료되었습니다.', {
              className: 'excel-icon'
            });
            eventBus.$emit('globalExcelDownload', response.data.url);
          }
          state.jobId = null;
          clearInterval(state.timer);
          state.timer = null;
        }
      })
      .catch((err) => {
        eventBus.$emit('DialogPopup', {
          useDialog: true,
          messageHTML: `<p class="txt">${err.message || err}</p>`,
          getBtnName: '확인',
          getButtonEvent: () => {}
        });
      });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/ticket/index.js